import { MatsForAccount } from "@mezo/api"
import { useQuery } from "@tanstack/react-query"

import { selectWalletAddress, useDappSelector } from "#/redux-state"
import {
  ONE_MINUTE_IN_SECONDS,
  ONE_SECOND_IN_MILLISECONDS,
  PORTAL_API_URL_V2,
  queryKeysFactory,
} from "#/shared/constants"
import { safeFetch } from "#/shared/utils"

const staleTime = ONE_MINUTE_IN_SECONDS * 60 * ONE_SECOND_IN_MILLISECONDS

const useFetchMatsFor = (address: string | null) => {
  const url = new URL(`account/${address}/mats`, PORTAL_API_URL_V2)

  return useQuery<MatsForAccount>({
    enabled: !!address,
    queryKey: [...queryKeysFactory.userKeys.mats(), address],
    queryFn: async () => {
      if (!address) {
        throw new Error("No address found for fetching mats")
      }

      const matsForAccount = await safeFetch<MatsForAccount>(
        url,
        "Failed to fetch mats",
      )

      return matsForAccount
    },
    staleTime,
    refetchInterval: staleTime,
    refetchOnWindowFocus: false,
  })
}

const useFetchMats = () => {
  const address = useDappSelector(selectWalletAddress)

  return useFetchMatsFor(address)
}

export default useFetchMats
